import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=7d2ebd52&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=7d2ebd52&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2ebd52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d2ebd52')) {
      api.createRecord('7d2ebd52', component.options)
    } else {
      api.reload('7d2ebd52', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=7d2ebd52&scoped=true", function () {
      api.rerender('7d2ebd52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/echartZyz/components/BarChart.vue"
export default component.exports